// @flow

// Libs
import React, { Component } from 'react'
import { Link } from 'react-router-dom'

// Utils
import getUrl from 'hfty-utils/url'

// Constants
import {
  ATTR_RECOMMENDATION_ID,
  ATTR_MAP_REPORTS,
  ATTR_CONTROLLER_FILES,
  ATTR_STATUS,
  ATTR_CONTROLLER,
  REPORTS_MAP_REPORT_ROUTE,
} from '../constants'
import { COMPLETE } from 'hfty-model-recommendations'

// Columns config
import COLUMNS from '../columnsConfig'

// Types
import { RecommendationRecord } from '../../types'

// Styles
import { grey, white } from 'hfty-styles/src/colors'

const styles = {
  recordBtn: {
    display: 'block',
    padding: '3px 9px',
    marginBottom: 5,
    borderRadius: 3,
    backgroundColor: grey(0.8),
    color: white(),
    textDecoration: 'none',
  },
}

// Props type
type Props = {
  children?: any,
  token: string,
  routerQuery: string,
}

// Exports
export default function recommendationsTable (RecommendationDataTable: Function): Function {
  return class RecommendationsDataTable extends Component {
    props: Props
    renderer: { [string]: Function }

    constructor (props: Props) {
      super(props)

      this.renderer = {
        [ATTR_MAP_REPORTS]: this.renderMapReportsBtn.bind(this),
        [ATTR_CONTROLLER_FILES]: this.renderControllerFilesBtn.bind(this),
      }
    }

    renderMapReportsBtn (record: RecommendationRecord): ?React.Element<any> {
      if (record[ATTR_STATUS] === COMPLETE) {
        return (
          <Link
            style={styles.recordBtn}
            to={`${REPORTS_MAP_REPORT_ROUTE}/${record[ATTR_RECOMMENDATION_ID]}`}
          >
            PDF
          </Link>
        )
      }
    }

    renderControllerFilesBtn (record: RecommendationRecord): ?React.Element<any> {
      if (record[ATTR_STATUS] === COMPLETE && record[ATTR_CONTROLLER]) {
        return (
          <a
            style={styles.recordBtn}
            href={
              getUrl({
                path: `blobstore/${record[ATTR_CONTROLLER]}`,
                excludeTrailingSlash: true,
                queryParams: {
                  download: true,
                },
                token: this.props.token,
              })
            }
            onClick={(e: Object) => {
              e.stopPropagation()
            }}
          >
            Download
          </a>
        )
      }
    }

    render (): React.Element<any> {
      return (
        <RecommendationDataTable
          columns={COLUMNS}
          renderer={this.renderer}
          defaultColumn={ATTR_RECOMMENDATION_ID}
          tools={this.props.children}
          routerQuery={this.props.routerQuery}
        />
      )
    }
  }
}
